module.exports = __webpack_public_path__ + "static/media/awlr-gps.fd44a19b.svg";